import { useCallback, useEffect, useRef, useState } from "react";
import { getAccesparkCycles } from "modules/monitoreo/services/ciclosAccespark";
import { mapAccesparkCycles } from "../model/accesparkModel";
export default function useAccesparkHistory(type) {
  const [cycles, setCycles] = useState([]),
    [loading, setLoading] = useState(false),
    [error, setError] = useState(null),
    [lastUpdated, setLastUpdated] = useState(null);
  const mounted = useRef(false),
    pending = useRef(null);
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  const loadCycles = useCallback(async () => {
    if (pending.current) return pending.current;
    setLoading(true);
    setError(null);
    pending.current = (async () => {
      try {
        const list = await getAccesparkCycles(type);
        if (mounted.current) {
          setCycles(mapAccesparkCycles(list));
          setLastUpdated(new Date().toISOString());
        }
      } catch (error) {
        if (mounted.current) setError(error.message);
      } finally {
        pending.current = null;
        if (mounted.current) setLoading(false);
      }
    })();
    return pending.current;
  }, [type]);
  return { cycles, loading, error, lastUpdated, loadCycles };
}
